import { useRef } from 'react';
import { useCurrentRefinements, useInstantSearch } from 'react-instantsearch';

// Hides a facet with no matching values unless it's selected or in `alwaysVisible`.
export const useVisibleAttributes = (attributes: string[], alwaysVisible: string[]): string[] => {
    const { results, status } = useInstantSearch();
    const { items: currentRefinements } = useCurrentRefinements();
    const lastVisibleRef = useRef<string[]>(attributes);

    // Dynamic widgets resolve facets progressively, so mid-search results can look briefly empty
    // for an attribute that isn't actually empty — only trust the check once search has settled.
    if (status !== 'idle') {
        return lastVisibleRef.current;
    }

    const visible = attributes.filter((attribute) => {
        if (alwaysVisible.includes(attribute)) return true;

        const isSelected = currentRefinements.some(
            (refinement) => refinement.attribute === attribute,
        );
        if (isSelected) return true;

        const facetValues = results.getFacetValues(attribute, {});
        return Array.isArray(facetValues) && facetValues.length > 0;
    });

    lastVisibleRef.current = visible;
    return visible;
};
